import { render, staticRenderFns } from "./SurveyQuestionList.vue?vue&type=template&id=70721a8e&scoped=true&"
import script from "./SurveyQuestionList.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionList.vue?vue&type=style&index=0&id=70721a8e&lang=scss&scoped=true&"
import style1 from "./SurveyQuestionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70721a8e",
  null
  
)

export default component.exports